import { render, staticRenderFns } from "./PersonalInfoBookingPage.vue?vue&type=template&id=971bb486&"
import script from "./PersonalInfoBookingPage.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoBookingPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoBookingPage.vue?vue&type=style&index=0&id=971bb486&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports